<template>
  <el-collapse
    v-model="collapseInsurance"
    class="insurance-collapse"
  >
    <el-collapse-item
      v-for="(insurance, id) in patientInsurances"
      :key="id"
      :title="insuranceTitles[id]"
      :name="camelize(insuranceTitles[id])"
    >
      <el-form
        :model="insurance"
        :rules="rules"
        ref="userInsuranceForm"
        label-position="top"
        autocomplete="off"
      >
        <el-form-item
          label="Insurance"
          prop="planCode"
        >
          <el-select
            filterable
            style="width: 100%"
            v-model="insurance.planCode"
            placeholder="Select insurance"
          >
            <el-option
              value=""
              disabled
              selected
            >
              Select insurance
            </el-option>
            <el-option
              v-for="ins in insurances"
              :key="ins.planCode"
              :label="ins.name"
              :value="ins.code"
            />
          </el-select>
        </el-form-item>

        <el-row :gutter="24">
          <el-col
            :lg="12"
            :md="24"
            :sm="24"
            :xs="24"
          >
            <el-form-item
              style="text-align: center"
              label="Insurance Front Side"
              prop="frontSide"
              v-if="typeof insurance.frontSide !== 'undefined'"
            >
              <Uploader
                :base64.sync="insurance.frontSide"
                @imageUploaded="frontSideUploaded(id)"
                @showLoader="showLoader"
                :disabled="!insurance.planCode ? true : false"
                :tooltip-text="!insurance.planCode ? 'Please select insurance first' : ''"
                :key="'front' + id"
              />
            </el-form-item>
          </el-col>

          <el-col
            :lg="12"
            :md="24"
            :sm="24"
            :xs="24"
          >
            <el-form-item
              style="text-align: center"
              label="Insurance Back Side"
              prop="backSide"
              v-if="typeof insurance.backSide !== 'undefined'"
            >
              <Uploader
                :base64.sync="insurance.backSide"
                @imageUploaded="backSideUploaded(id)"
                @showLoader="showLoader"
                :disabled="!insurance.planCode ? true : false"
                :tooltip-text="!insurance.planCode ? 'Please select insurance first' : ''"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item
          label="Member Id"
          prop="memberId"
        >
          <el-input
            type="text"
            v-model="insurance.memberId"
            :disabled="!insurance.planCode ? true : false"
          />
        </el-form-item>

        <el-form-item
          label="Group Number"
          prop="groupNumber"
        >
          <el-input
            v-model="insurance.groupNumber"
            :disabled="!insurance.planCode ? true : false"
          />
        </el-form-item>

        <el-form-item class="submit-btn">
          <el-button
            type="primary"
            @click="submitForm('userInsuranceForm', id)"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import Uploader from '../form/Uploader';

export default {
  name: 'Insurance',
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    Uploader
  },
  data: () => ({
    insuranceTitles: [
      'Primary insurance',
      'Secondary insurance',
      'Tertiary insurance'
    ],
    insurances: [],
    patientInsurances: {},
    collapseInsurance: [],
    rules: {
      planCode: [
        { required: true, message: 'Please select Insurance', trigger: 'change' }
      ],
      frontSide: [
        { required: true, message: 'Please upload your insurance\'s front side image', trigger: 'change' }
      ],
      backSide: [
        { required: true, message: 'Please upload your insurance\'s back side image', trigger: 'change' }
      ],
      memberId: [
        { required: true, message: 'Please input Member ID', trigger: 'blur' }
      ],
      groupNumber: [
        { required: true, message: 'Please input Member ID', trigger: 'blur' }
      ]
    }
  }),
  created () {
    this.getInsurancesByState(this.user.address.state).then(() => {
      this.getPatientInsurances(this.user.patientNumber);
    });
  },
  methods: {
    showLoader() {
      this.$emit('screenLoading', true);
    },
    submitForm (formName, formId) {
      this.$refs[formName][formId].validate((valid) => {
        if (valid) {
          this.saveUserInsurance(formId);
        } else {
          return false;
        }
      });
    },
    saveUserInsurance (insuranceId = 0) {
      let insuranceTitle = this.insuranceTitles[insuranceId],
          fieldName = insuranceTitle.toLowerCase().replace(/\s/g, '_');
      this.$emit('screenLoading', true);
      this.storeInsurance(this.user.patientNumber, insuranceId).then((response) => {
        if (response.data.isSuccess) {
          this.saveInsuranceImages(this.patientInsurances[insuranceId]).then((status) => {
            this.$emit('screenLoading', false);
            if (status) {
              this.saveStatisticData(this.getSessionId(), {[fieldName+'_save']: 'true'});
              this.$message({
                showClose: true,
                message: 'Insurance is saved!',
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: 'Sorry! We could not save your insurance images!',
                type: 'warning'
              });
            }
          }).catch(() => {
            this.$emit('screenLoading', false);
            this.$message({
              showClose: true,
              message: 'Oops, something went wrong!',
              type: 'error'
            });
          });
        } else {
          this.$emit('screenLoading', false);
          this.$message({
            showClose: true,
            message: 'Sorry! We could not save your insurance!',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    storeInsurance (patientNumber = '', insuranceId = 0) {
      return this.$axios('/Insurance/StoreInsurance', {
        method: 'PUT',
        data: {
          patientNumber: patientNumber,
          practiceId: 0,
          insurance: {
            planCode: this.patientInsurances[insuranceId].planCode,
            groupNumber: this.patientInsurances[insuranceId].groupNumber,
            memberId: this.patientInsurances[insuranceId].memberId,
            isPrimary: insuranceId === 0 ? true : false,
            isNew: this.patientInsurances[insuranceId].isNew,
            startDate: null,
            endDate: null
          },
          userName: 'webreg'
        }
      });
    },
    saveInsuranceImages (insurance = {}) {
      const promises = [];
      promises.push(
          new Promise((resolve, reject) => {
            this.$axios('/Insurance/SaveInsuranceImage', {
              method: 'PUT',
              data: {
                planCode: insurance.planCode,
                patientNumber: this.$route.params.patientNumber,
                blobData: insurance.frontSide.split(',')[1],
                isFrontImage: 'true'
              }
            }).then((response) => {
              resolve(response.data.isSuccess);
            }).catch(() => {
              reject();
            });
          })
      );
      promises.push(
          new Promise((resolve, reject) => {
            this.$axios('/Insurance/SaveInsuranceImage', {
              method: 'PUT',
              data: {
                planCode: insurance.planCode,
                patientNumber: insurance.patientNumber,
                blobData: insurance.backSide.split(',')[1],
                isFrontImage: 'false'
              }
            }).then((response) => {
              if (response.data.isSuccess) {
                resolve();
              } else {
                reject('saveError');
              }
            }).catch(() => {
              reject('apiError');
            });
          })
      );

      return Promise.all(promises);
    },
    getInsurancesByState (state = '') {
      return this.$axios('/Insurance/GetInsurancePlansByState', {
        method: 'GET',
        params: {
          state: state
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          this.insurances = response.data.data;
        } else {
          this.$message({
            showClose: true,
            message: 'We could not get insurances!',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    getPatientInsurances (patientNumber = '') {
      var self = this;
      return this.$axios('/Insurance/GetPatientInsurances', {
        method: 'GET',
        params: {
          patientNumber: patientNumber
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          this.patientInsurances = response.data.data.filter((insurance) => insurance.isActive).sort((item) => item.isPrimary).resize(3, {
            frontSide: '',
            backSide: '',
            isNew: true
          });
          var promises = [];
          for (const insurance of this.patientInsurances) {
            if (insurance.planId) {
              insurance.isNew = false;
              insurance.groupNumber = parseInt(insurance.groupNumber);
              promises.push(
                  new Promise((resolve) => {
                    this.getInsuranceImages(insurance).then(() => {
                      resolve(true);
                    });
                  })
              );
            }
          }
          Promise.all(promises).then(() => {
            self.$emit('screenLoading', false);
          });
        } else {
          this.$emit('screenLoading', false);
          this.$message({
            showClose: true,
            message: 'Sorry! We could not get your insurances!',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    getInsuranceImages (insurance = {}) {
      return this.$axios('/Insurance/GetInsuranceImages', {
        method: 'GET',
        params: {
          patientNumber: this.user.patientNumber,
          planId: insurance.planId,
          policyNumber: insurance.policyNumber
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          const frontSide = response.data.data.filter((el) => {return el.imageDataString.length && el.isFrontImage;});
          this.$set(insurance, 'frontSide', (frontSide.length) ? 'data:image/png;base64,' + frontSide[0].imageDataString : '');

          const backSide = response.data.data.filter((el) => {return el.imageDataString.length && !el.isFrontImage;});
          this.$set(insurance, 'backSide', (backSide.length) ? 'data:image/png;base64,' + backSide[0].imageDataString : '');
        } else {
          this.$message({
            showClose: true,
            message: 'Sorry! We could not get insurances images!',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    frontSideUploaded (id = '') {
      this.$forceUpdate();
      this.$emit('screenLoading', true);
      this.$axios('/Ocr/insurance', {
        method: 'POST',
        data: {
          blobData: this.patientInsurances[id].frontSide.split(',')[1],
          insurance: this.patientInsurances[id].planCode
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          this.patientInsurances[id].ocrId = response.data.data.id;
          response.data.data.fields.map((field) => {
            this.$set(this.patientInsurances[id], [this.camelize(field.name)], (field.name === 'GroupNumber') ? parseInt(field.value) || '' : field.value);
          });
          this.$emit('screenLoading', false);
        } else {
          this.$message({
            showClose: true,
            message: 'We could not recognize data from your insurance card',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    },
    backSideUploaded (id = '') {
      this.$forceUpdate();
      this.$emit('screenLoading', true);
      this.$axios('/Ocr/insuranceCode', {
        method: 'POST',
        data: {
          blobData: this.patientInsurances[id].backSide.split(',')[1]
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data.data) {
            this.$set(this.patientInsurances[id], 'memberId', response.data.data.data.memberId || '');
            this.$set(this.patientInsurances[id], 'groupNumber', parseInt(response.data.data.data.groupNumber) || '');
          }
          this.$emit('screenLoading', false);
        } else {
          this.$message({
            showClose: true,
            message: 'We could not recognize data from your insurance card',
            type: 'warning'
          });
        }
      }).catch(() => {
        this.$emit('screenLoading', false);
        this.$message({
          showClose: true,
          message: 'Oops, something went wrong!',
          type: 'error'
        });
      });
    }
  }
};
</script>
